
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SignsAndSymptomsOfCervicalNerveRootInvolvement',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/SignsAndSymptomsOfCervicalNerveRootInvolvement.vue